var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsHorizontal0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 8.00002C6.66667 7.26364 7.26362 6.66669 8 6.66669C8.73638 6.66669 9.33333 7.26364 9.33333 8.00002C9.33333 8.7364 8.73638 9.33335 8 9.33335C7.26362 9.33335 6.66667 8.7364 6.66667 8.00002Z",
    fill: "#D1D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 8.00002C11.3333 7.26364 11.9303 6.66669 12.6667 6.66669C13.403 6.66669 14 7.26364 14 8.00002C14 8.7364 13.403 9.33335 12.6667 9.33335C11.9303 9.33335 11.3333 8.7364 11.3333 8.00002Z",
    fill: "#D1D1D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.00002C2 7.26364 2.59695 6.66669 3.33333 6.66669C4.06971 6.66669 4.66667 7.26364 4.66667 8.00002C4.66667 8.7364 4.06971 9.33335 3.33333 9.33335C2.59695 9.33335 2 8.7364 2 8.00002Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsHorizontal0);
export default __webpack_public_path__ + "static/media/dots-horizontal0.b51b94b3038232f0b3d1190785137fc4.svg";
export { ForwardRef as ReactComponent };